<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let value = null
    export let placeholder = 'Buscar'

    function search() {
        dispatch('enter')
    }

</script>

<div class="search-wrapper">
    <input
        bind:value={value}
        on:keyup={e => e.code === 'Enter' && search()}
        type="text"
        class="input search-input"
        {placeholder}
    >
    <button type="button" class="search-button" aria-label="Buscar" on:click={search}>
        <i class="fas fa-search"></i>
    </button>
</div>

<style>
    .search-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
    }

    .search-input {
        flex: 1;
        min-width: 0;
        width: 100%;
        padding-right: 2.5rem;
    }

    .search-button {
        position: absolute;
        top: 3px;
        right: 3px;
        bottom: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        border: none;
        border-radius: 4px;
        background: var(--color-primary, #098E37);
        color: #fff;
        cursor: pointer;
        font-size: 0.75rem;
        transition: background 0.15s ease;
    }

    .search-button:hover {
        background: #077a2f;
    }

    .search-button:focus {
        outline: none;
        box-shadow: 0 0 0 0.125em rgba(9, 142, 55, 0.35);
    }
</style>
